import { EntityWithDimensions } from "common/types/EntityWithDimensions";

export const composeGetIsOverWeight =
  (maxWeight: number) =>
  ({ weight }: Pick<EntityWithDimensions, "weight">) =>
    Number(weight ?? 0) > maxWeight;
